export const SET_DOCUMENTS = 'SET_DOCUMENTS';
export const SET_DOCUMENT_TYPE = 'SET_DOCUMENT_TYPE';
